import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4" }
const _hoisted_3 = { class: "flex items-start" }
const _hoisted_4 = { class: "text-sm text-amber-700 dark:text-amber-300" }
const _hoisted_5 = { class: "space-y-4" }
const _hoisted_6 = { class: "max-h-64 overflow-y-auto space-y-3" }
const _hoisted_7 = { class: "flex items-start justify-between mb-2" }
const _hoisted_8 = { class: "text-sm font-medium text-gray-900 dark:text-gray-100" }
const _hoisted_9 = { class: "text-sm text-gray-600 dark:text-gray-400 mb-3 line-clamp-2" }
const _hoisted_10 = { class: "space-y-1" }
const _hoisted_11 = { class: "text-xs text-red-600 dark:text-red-400 space-y-1 pl-2" }
const _hoisted_12 = { class: "flex flex-col sm:flex-row gap-3 w-full sm:w-auto" }

import { computed } from 'vue'
import BaseModal from '@/components/common/BaseModal.vue'
import { AlertTriangle, Save } from 'lucide-vue-next'

export interface IncompleteQuestion {
  index: number
  question: string
  issues: string[]
  isComplete: boolean
}

interface Props {
  isVisible: boolean
  incompleteQuestions: IncompleteQuestion[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IncompleteQuestionsModal',
  props: {
    isVisible: { type: Boolean },
    incompleteQuestions: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props

// Methods to centralize closing and confirming logic
const closeModal = () => {
  // Perform any cleanup here if needed, then emit close
  // Example: focus management or resetting state in parent can be handled there
  emitClose()
}

const confirmSave = () => {
  // Any pre-confirm checks could go here before emitting
  emitConfirm()
}

// Create typed emit functions
const emit = __emit

function emitConfirm() {
  emit('confirm')
}

function emitClose() {
  emit('close')
}

// Computed properties
const incompleteCount = computed(() => {
  return props.incompleteQuestions.filter(q => !q.isComplete).length
})

const completeCount = computed(() => {
  return props.incompleteQuestions.filter(q => q.isComplete).length
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": _ctx.isVisible,
    title: "Incomplete Questions Detected",
    subtitle: "Some questions don't meet the required criteria",
    icon: _unref(AlertTriangle),
    size: "2xl",
    type: "warning",
    "show-footer": true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          onClick: closeModal,
          class: "px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-600 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
        }, " Review & Update "),
        _createElementVNode("button", {
          onClick: confirmSave,
          class: "px-4 py-2 text-sm font-medium text-white bg-amber-600 hover:bg-amber-700 focus:ring-2 focus:ring-amber-500 focus:border-amber-500 rounded-lg transition-colors"
        }, [
          _createVNode(_unref(Save), { class: "w-4 h-4 mr-2 inline" }),
          _createTextVNode(" Save Anyway (" + _toDisplayString(completeCount.value) + " question" + _toDisplayString(completeCount.value !== 1 ? 's' : '') + ") ", 1)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(AlertTriangle), { class: "w-5 h-5 text-amber-600 dark:text-amber-400 mt-0.5 mr-3 flex-shrink-0" }),
            _createElementVNode("div", null, [
              _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "font-medium text-amber-900 dark:text-amber-100 mb-2" }, " Action Required ", -1)),
              _createElementVNode("p", _hoisted_4, " You have " + _toDisplayString(incompleteCount.value) + " incomplete question" + _toDisplayString(incompleteCount.value !== 1 ? 's' : '') + " that " + _toDisplayString(incompleteCount.value !== 1 ? "don't" : "doesn't") + " meet the required criteria. You can either review and update them or proceed to save anyway. ", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[4] || (_cache[4] = _createElementVNode("h5", { class: "text-sm font-medium text-gray-900 dark:text-gray-100 mb-3" }, " Incomplete Questions: ", -1)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incompleteQuestions.filter(q => !q.isComplete), (question, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "border border-red-200 dark:border-red-800 rounded-lg p-4 bg-red-50 dark:bg-red-900/10"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h6", _hoisted_8, " Question " + _toDisplayString(question.index + 1), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-xs px-2 py-1 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-full" }, " Incomplete ", -1))
                ]),
                _createElementVNode("p", _hoisted_9, _toDisplayString(question.question || 'No question text entered'), 1),
                _createElementVNode("div", _hoisted_10, [
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-xs font-medium text-red-700 dark:text-red-300" }, "Items to review:", -1)),
                  _createElementVNode("ul", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.issues, (issue) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: issue,
                        class: "flex items-center gap-2"
                      }, [
                        _cache[2] || (_cache[2] = _createElementVNode("span", { class: "w-1 h-1 bg-red-500 rounded-full flex-shrink-0" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(issue), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            }), 128))
          ])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "bg-gray-50 dark:bg-gray-800 rounded-lg p-4" }, [
          _createElementVNode("h5", { class: "text-sm font-medium text-gray-900 dark:text-gray-100 mb-2" }, " What would you like to do? "),
          _createElementVNode("div", { class: "space-y-2 text-sm text-gray-600 dark:text-gray-400" }, [
            _createElementVNode("div", { class: "flex items-center" }, [
              _createElementVNode("span", { class: "w-2 h-2 bg-blue-500 rounded-full mr-2" }),
              _createElementVNode("strong", { class: "mr-1" }, "Review and update:"),
              _createTextVNode(" Return to complete the missing information ")
            ]),
            _createElementVNode("div", { class: "flex items-center" }, [
              _createElementVNode("span", { class: "w-2 h-2 bg-amber-500 rounded-full mr-2" }),
              _createElementVNode("strong", { class: "mr-1" }, "Save anyway:"),
              _createTextVNode(" Save the exam with only the complete questions ")
            ])
          ])
        ], -1))
      ])
    ]),
    _: 1
  }, 8, ["is-visible", "icon"]))
}
}

})